export default function paginationIndicator() {

    const pagination = document.querySelector(".js-pagination");
    if(!pagination) {
        return;
    }
    const indicator = pagination.querySelector(".js-pagination__indicator");
    const currentPage = pagination.querySelector(".js-pagination__current");
    const totalPages = pagination.querySelector(".js-pagination__all");
    const resultsContainer = document.querySelector(".js-results-container");

    // Get current and total page values
    if(resultsContainer) {
        let _currentPage = resultsContainer.dataset.page;
        let _totalPages = document.querySelector(".js-results-container").dataset.max;

        currentPage.innerText = _currentPage;
        totalPages.innerText = _totalPages;

        // update progress bar
        indicator.style.width = _currentPage / _totalPages * 100 + '%';
    }
  };
